<template>
    <select class="form-select d-none" :class="class" :id="id" ref="select" :value="modelValue">
        <option></option>
        <option :disabled="item.allowed === false" :key="item.id || item.value || item.label" :value="item.id || item.value || item.label" v-for="(item) in options">
            {{ item.title || item.label }}
        </option>
    </select>
</template>

<script setup>
    const props = defineProps({
        class: { type: [Array, Object, String] },
        modelValue: { type: { Number, String } },
        noResults: { default: "沒有找到相符的項目", type: String },
        options: { type: Array },
        placeholder: { type: String }
    });

    const id = nextId();
    const select = ref();

    const emit = defineEmits(["change", "update:modelValue"]);

    onMounted(() => {
        const target = $(select.value);
        const dropdownCssClass = target.parents(".modal-content").length ? undefined : "z:1400!";

        target.css("width", "100%").select2({
            dropdownCssClass,
            language: { noResults: () => props.noResults },
            minimumResultsForSearch: Infinity,
            placeholder: props.placeholder,
            theme: "bootstrap-5"
        }).on("select2:select", () => {
            emit("update:modelValue", select.value.value);
            emit("change");
        });
    });

    onUnmounted(() => {
        $(select.value).select2("destroy");
    });

    watch(() => props.modelValue, () => {
        $(select.value).val(props.modelValue).trigger("change");
    });
</script>
